module.exports = __webpack_public_path__ + "static/henho10-fa2979de8485e6cc35526baac17e73dc.jpg";